import axios from "axios";

const resolveApiBaseUrl = () => {
  const configuredUrl = (process.env.REACT_APP_API_URL || "").trim();
  if (configuredUrl) {
    return configuredUrl.replace(/\/+$/, "");
  }

  if (typeof window === "undefined") {
    return "http://localhost:5002/api";
  }

  const hostname = window.location.hostname || "";
  const isLocalhost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1";

  return isLocalhost ? "http://localhost:5002/api" : "/api";
};

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
});

// Attach token for protected routes
api.interceptors.request.use((config) => {
  const pathname = window.location.pathname || "";
  const isAdminRoute = pathname.startsWith("/admin");
  const isTeacherRoute = pathname.startsWith("/teacher");
  const isParentRoute = pathname.startsWith("/parent");

  let token = "";
  if (isAdminRoute) token = localStorage.getItem("adminToken") || localStorage.getItem("token") || "";
  else if (isTeacherRoute) token = localStorage.getItem("teacherToken") || localStorage.getItem("token") || "";
  else if (isParentRoute) token = localStorage.getItem("parentToken") || localStorage.getItem("token") || "";
  else token = localStorage.getItem("token") || localStorage.getItem("adminToken") || localStorage.getItem("teacherToken") || localStorage.getItem("parentToken") || "";

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
